import { useEffect } from 'react'
import { themeAtom } from 'atoms'
import { userAtom } from '@/atoms/_globalAtoms'
import { useSetRecoilState, useRecoilValue } from 'recoil'

export const useApplyTheme = () => {
  const setTheme = useSetRecoilState(themeAtom)

  // gathers the user's current theme
  // Backend returns Prisma enum values (AUTOMATIC, LIGHT, DARK, HIGH_CONTRAST)
  // Normalize to lowercase with hyphens to match UI theme values
  const user = useRecoilValue(userAtom)
  const selectedTheme = user?.uiTheme?.toLowerCase().replace(/_/g, '-')
  const isAutomatic = selectedTheme === 'automatic' || !selectedTheme

  // determines the user's operating system theme
  const windowScheme = window?.matchMedia('(prefers-color-scheme: dark)')
  const automaticTheme = windowScheme.matches ? 'dark' : 'light'

  useEffect(() => {
    // sets the theme based on whether it is automatic or not on initial load
    const userTheme = isAutomatic ? automaticTheme : selectedTheme
    setTheme(user ? userTheme : automaticTheme)

    // changeScheme determines whether the user's OS is dark or not
    const changeScheme = (e: MediaQueryListEvent) => {
      const theme = e.matches ? 'dark' : 'light'
      if (isAutomatic) {
        setTheme(theme)
      }
    }

    // apply the automatic theme (if enabled) upon the user changing their OS's theme
    if (user) {
      windowScheme.addEventListener('change', changeScheme, { passive: true })
    }
    return () => {
      windowScheme.removeEventListener('change', changeScheme)
    }

    // eslint-disable-next-line
  }, [user?.uiTheme])
}

export default useApplyTheme
